import { Helmet } from "react-helmet";

import { useElementContext, useBrand } from "@ten24/slatwall-storefront-react-private/global";
import { useContentContext } from "../../contexts/ContentContext";

import DynamicPage from "../DynamicPage/DynamicPage";
import { PageContentRow } from "../../components/PageContentRow/PageContentRow";

const BrandPage = () => {
  const pageData = useContentContext();
  const { brandResponse, slug, subHeading } = useBrand();
  const { ListingBanner, SearchListingStack } = useElementContext();

  const { branchSearchListing, brandHeaderStyle } = pageData.templateData || {};
  if (!branchSearchListing) return <DynamicPage />;

  const {
    brandName,
    images,
    brandDescription,
    settings: { brandHTMLTitleString } = {},
  } = brandResponse?.data?.[0] || {};

  const title = pageData?.title || brandName;
  const pageLogo = pageData?.pageLogo || images?.at(0);
  const description = pageData?.description || brandDescription;

  return (
    <DynamicPage>
      {({ renderDynamicContent }) => (
        <>
          {brandHTMLTitleString && <Helmet title={brandHTMLTitleString} />}
          <PageContentRow>
            <ListingBanner
              subHeading={subHeading}
              heading={title}
              images={[pageLogo]}
              description={description}
              isCollapsible={brandHeaderStyle === "compact"}
            />
          </PageContentRow>
          {renderDynamicContent()}
          {brandResponse.isLoaded && brandResponse.data.length > 0 && (
            <SearchListingStack
              hide="brand"
              brandSlug={slug}
              {...branchSearchListing}
              initPreFilter={{
                brand_slug: slug,
              }}
            />
          )}
        </>
      )}
    </DynamicPage>
  );
};

export default BrandPage;
